export const Image = ({
  width = 20,
  height = 20,
  color = '#121212',
  fillOpacity = 1,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_215_4905)">
        <path
          d="M3 3H16V10H18V3C18 1.897 17.103 1 16 1H3C1.897 1 1 1.897 1 3V15C1 16.103 1.897 17 3 17H11V15H3V3Z"
          fill={color}
          fillOpacity={fillOpacity}
        />
        <path
          d="M7 9L4 13H15L11 7L8 11L7 9Z"
          fill={color}
          fillOpacity={fillOpacity}
        />
        <path
          d="M18 12H16V15H13V17H16V20H18V17H21V15H18V12Z"
          fill={color}
          fillOpacity={fillOpacity}
        />
      </g>
      <defs>
        <clipPath id="clip0_215_4905">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
